// A spreadsheet row a human reads as empty. Excel keeps cells that were once typed in and
// later cleared (they persist as empty-string cells), so a workbook's used range routinely
// runs dozens of rows past the last reading and sheet_to_json emits those as `{reading: "",
// note: ""}` objects. Validating them fails the whole file on "must be provided" errors that
// point at nothing the operator can see, so they're dropped before validation.
// A partially filled row is NOT blank — that's a real mistake and must still be reported.
export const isBlankUploadRow = (row: Record<string, unknown>): boolean =>
  Object.values(row).every(
    value => value === undefined || value === null || String(value).trim() === "",
  );
